import React from 'react';
import { RelationshipsView } from '@/components/views/RelationshipsView';

export const RelationshipsPage = () => <RelationshipsView />;
